import { Theme } from "common";

export const dialogStyles = {
  root: {
    "& .MuiDialog-paper": {
      width: 594,
      maxHeight: 560,
    },
    "& *": {
      fontFamily: "Source Sans Pro, sans-serif",
    },
    "&.applicantDialogBox .MuiDialog-paper": {
      maxHeight: "unset",
    },
  },
  dialogContent: {
    padding: 0,
    borderBottom: 0,
    "& p": {
      margin: 0,
    },
    "& .modalBox": {
      "& tbody tr td:nth-of-type(2)": {
        maxWidth: 250,
      },
      "& tbody tr td:first-of-type": {
        width: 50,
      },
    },
  },
  dialogTitle: {
    minHeight: 50,
    padding: "10px 20px",
    "& p": {
      fontWeight: 500,
    },
  },
  dialogAction: {
    height: 40,
    "& .MuiButton-root": {
      color: "#009ABB",
      fontSize: 14,
      fontWeight: Theme.typography.fontWeightBold,
    },
  },
};
